var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfResultsClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00026 14.6661C11.6821 14.6661 14.6669 11.6813 14.6669 7.99948C14.6669 4.31758 11.6821 1.33281 8.00026 1.33281C4.31836 1.33281 1.33359 4.31758 1.33359 7.99948C1.33359 11.6813 4.31836 14.6661 8.00026 14.6661Z",
    stroke: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00547 7.00508C7.4532 7.00508 7.00547 7.45281 7.00547 8.00508C7.00547 8.55734 7.4532 9.00508 8.00547 9.00508C8.55774 9.00508 9.00547 8.55734 9.00547 8.00508C9.00547 7.45281 8.55774 7.00508 8.00547 7.00508ZM8.00547 7.00508V4.66563M10.0101 10.0128L8.711 8.71375",
    stroke: "url(#paint1_linear_0_4)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 1.33359,
    y1: 7.99948,
    x2: 12.2964,
    y2: 8.04429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 7.00547,
    y1: 7.33922,
    x2: 9.47591,
    y2: 7.34489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfResultsClock);
export default __webpack_public_path__ + "static/media/cf-results-clock.3f90719737d61cca4edfcb817d02d08e.svg";
export { ForwardRef as ReactComponent };